import { render } from "./SearchMore.vue?vue&type=template&id=296dfbd4"
import script from "./SearchMore.vue?vue&type=script&lang=js"
export * from "./SearchMore.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__